export const UPDATE_STORE_HOME_PAGE =
  'parkplus_store_v2/UPDATE_STORE_HOME_PAGE';
export const UPDATE_ML_EXCLUSIVE_PAGE =
  'parkplus_store_v2/UPDATE_ML_EXCLUSIVE_PAGE';

export const UPDATE_CART = 'parkplus_store_v2/UPDATE_CART';
export const UPDATE_LISTING = 'parkplus_store_v2/UPDATE_LISTING';
export const UPDATE_DELIVERY_ADDRESS =
  'parkplus_store_v2/UPDATE_DELIVERY_ADDRESS';
export const UPDATE_LISTING_FILTER_SUBCATEGORY =
  'parkplus_store_v2/UPDATE_LISTING_FILTER_SUBCATEGORY';
export const UPDATE_SORT_AND_FILTERS =
  'parkplus_store_v2/UPDATE_SORT_AND_FILTERS';
export const UPDATE_PDP = 'parkplus_store_v2/UPDATE_PDP';
export const CATEGORY_LISTING = "parkplus_store_v2/CATEGORY_LISTING";
export const CATEGORY_DESCRIPTION = "parkplus_store_v2/CATEGORY_DESCRIPTION";
